import React from 'react';

const About = () => {
  return (
    <div className="container section">
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '3rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <h1 className="section-title" style={{ marginBottom: '2rem', textAlign: 'left' }}>About Us</h1>
        
        <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563' }}>
          <p style={{ marginBottom: '1.5rem' }}>
            Welcome to <strong>Sunshine Travels</strong>, your premier gateway to the untamed beauty of India's wilderness. We are passionate about connecting people with nature, offering unforgettable wildlife safaris, breathtaking Himalayan treks, and immersive travel experiences across the subcontinent.
          </p>

          <h3 style={{ fontSize: '1.4rem', color: '#111', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 'bold' }}>Our Mission</h3>
          <p style={{ marginBottom: '1.5rem' }}>
            Our mission is simple: to provide authentic, sustainable, and awe-inspiring travel experiences that foster a deep appreciation for the natural world. We believe that by bringing people closer to nature, we can inspire a global movement towards conservation and environmental stewardship.
          </p>

          <h3 style={{ fontSize: '1.4rem', color: '#111', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 'bold' }}>Why Choose Us?</h3>
          <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><strong>Expert Guides:</strong> Our team consists of seasoned naturalists, certified mountaineers, and local experts who know the terrain inside out.</li>
            <li><strong>Sustainable Travel:</strong> We are committed to eco-friendly practices that minimize our carbon footprint and support local communities.</li>
            <li><strong>Tailored Experiences:</strong> Whether you're a hardcore adventurer or looking for a peaceful nature retreat, we customize our tours to meet your specific needs.</li>
            <li><strong>Safety First:</strong> Your safety is our top priority. We use top-of-the-line equipment and adhere to strict safety protocols on all our trips.</li>
          </ul>

          <h3 style={{ fontSize: '1.4rem', color: '#111', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 'bold' }}>Our Story</h3>
          <p>
            Sunshine Travels was born out of a shared love for the great outdoors. What started as a small group of friends exploring the remote corners of the Himalayas has grown into a full-fledged adventure travel company. Today, we are proud to share our passion with thousands of travelers from around the globe, helping them discover the majestic wildlife, towering peaks, and hidden natural treasures of India.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
